import { Field, FieldDescription, FieldGroup, FieldLabel } from '@azelis/ui/components/field';

import { FileUploadField } from './file-upload-field';
import { useSubmitWizard } from './submit-wizard-context';

export function ExtraDocumentsStep() {
  const { extraDocuments, setExtraDocuments } = useSubmitWizard();

  return (
    <FieldGroup className="mx-auto w-80 gap-6 py-8">
      <Field>
        <FieldLabel htmlFor="extra-documents">Upload extra documents (PDF only)</FieldLabel>
        <FileUploadField
          accept=".pdf"
          emptyText="No files chosen"
          files={extraDocuments}
          id="extra-documents"
          multiple
          onFilesChange={setExtraDocuments}
        />
        {extraDocuments.length > 0 ? (
          <ul className="flex flex-col gap-1">
            {extraDocuments.map((file) => (
              <li key={file.name}>
                <FieldDescription>{file.name}</FieldDescription>
              </li>
            ))}
          </ul>
        ) : null}
      </Field>
    </FieldGroup>
  );
}
